<template>
  <p
    v-if="shouldDisplayGDPRNotice"
    class="text-static-default-low caption py-16 md:px-24"
  >
    <FormattedMessage :definition="translations[`page_${page}`]">
      <template #privacy>
        <RevLink
          class="text-inherit"
          target="_blank"
          :to="`${baseUrlWithLocale}/${CMS.LEGAL_PAGE}/${LEGAL_PAGE_NAME.DATA_PROTECTION}`"
        >
          {{ i18n(translations.link) }}
        </RevLink>
      </template>
    </FormattedMessage>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketBaseUrl } from '@backmarket/nuxt-module-marketplace/useMarketBaseUrl'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevLink } from '@ds/components/Link'

import {
  CMS,
  LEGAL_PAGE_NAME,
} from '../CheckoutLegalLinks/CheckoutLegalLinks.constants'

import translations from './GDPRNotice.translations'

defineProps<{ page: 'delivery' | 'payment' }>()

const i18n = useI18n()
const { baseUrlWithLocale } = useMarketBaseUrl('main')
const { marketplace } = useMarketplace()

const shouldDisplayGDPRNotice = computed(() => {
  return marketplace.marketplaceCode === 'EU'
})
</script>
